export const PRODUCT_TYPE_CONSTANTS = [
    {
        id: 1,
        name: "Qtr/Annually Run Coatings",
        leadtime: 20,
    },
    {
        id: 2,
        name: "DigitalDistinctions",
        leadtime: 20,
    },
    {
        id: 3,
        name: "Special Fab - All Products",
        leadtime: 10,
    },
    {
        id: 4,
        name: "TLI, Mono, Lami or IG - Custom Print or Paint",
        leadtime: 10,
    },
    {
        id: 5,
        name: "TLI, Mono, Lami or IG - Standard Print or Paint",
        leadtime: 7,
    },
    {
        id: 6,
        name: "TLI - Standard Coatings",
        leadtime: 7,
    },
    {
        id: 7,
        name: "Mono, Lami or IG - Standard Coatings",
        leadtime: 4,
    },
    {
        id: 8,
        name: "Kits",
        leadtime: 2,
    },
]

export const SALE_TERRITORY_TYPE_CONSTANTS = [
    {
        id: 1,
        name: "007 - Hoffman",
        email: "rhoffman@viracon.com"
    },
    {
        id: 2,
        name: "101 - Davidson",
        email: "Allend@addassoc.com"
    },
    {
        id: 3,
        name: "103 - Sawyer",
        email: "jsawyer@viracon.com"
    },
    {
        id: 4,
        name: "104 - Martineau & Co.",
        email: "nicole@mandcomp.com"
    },
    {
        id: 5,
        name: "105 - Kennedy",
        email: "akennedy@dv8glazing.com"
    },
    {
        id: 6,
        name: "107 - Hawkins",
        email: "mh@anchor-architectural.com"
    },
    {
        id: 7,
        name: "108 - Sweet",
        email: "jsweet@viracon.com"
    },
    {
        id: 8,
        name: "202 - Urich",
        email: "durich@archonfentech.com"
    },
    {
        id: 9,
        name: "203 - Carlson",
        email: "bcarlson@viracon.com"
    },
    {
        id: 10,
        name: "204 - Krier",
        email: "matt@truenorthfacades.com"
    },
    {
        id: 11,
        name: "205 - Honaman",
        email: "lhonaman@viracon.com"
    },
    {
        id: 12,
        name: "302 - Winkler",
        email: "mwinkler@viracon.com"
    },
    {
        id: 13,
        name: "303 - Johnson",
        email: "jeffjohnson@viracon.com"
    },
    {
        id: 14,
        name: "305 - PGP",
        email: "jhemby@pgp-usa.com"
    },
    {
        id: 15,
        name: "308 - Rigot",
        email: "jrigot@viracon.com"
    },
    {
        id: 16,
        name: "400 - Western Canada",
        email: "rhoffman@viracon.com"
    },
    {
        id: 17,
        name: "401 - Dorsey",
        email: "kdorsey@viracon.com"
    },
    {
        id: 18,
        name: "402 - O'Neill",
        email: "connor@orhize.com"
    },
    {
        id: 19,
        name: "403 - JPaal",
        email: "jack@bpaproducts.net"
    },
    {
        id: 20,
        name: "404 - JRobson",
        email: "jeff@bpaproducts.com"
    },
    {
        id: 21,
        name: "405 - Hoffman",
        email: "rhoffman@viracon.com"
    },
    {
        id: 22,
        name: "Puerto Rico - Rigot",
        email: "jrigot@viracon.com"
    },
    {
        id: 23,
        name: "Dominican Republic - Rigot",
        email: "jrigot@viracon.com"
    },
    {
        id: 24,
        name: "Bahamas - Rigot",
        email: "jrigot@viracon.com"
    },
    {
        id: 25,
        name: "Cayman Islands - Rigot",
        email: "jrigot@viracon.com"
    },
    {
        id: 26,
        name: "Misc. Latin America - Hoffman",
        email: "rhoffman@viracon.com"
    },
    {
        id: 27,
        name: "Mexico - Hoffman",
        email: "rhoffman@viracon.com"
    },
    {
        id: 28,
        name: "Costa Rica - Hoffman",
        email: "rhoffman@viracon.com"
    },
    {
        id: 29,
        name: "New Zealand – Hilgendorf",
        email: "mhilgendorf@viracon.com"
    },
    {
        id: 30,
        name: "Middle East – Hilgendorf",
        email: "mhilgendorf@viracon.com"
    },
    {
        id: 31,
        name: "South Korea – Hilgendorf",
        email: "mhilgendorf@viracon.com"
    },
    {
        id: 32,
        name: "Vietnam – Hilgendorf",
        email: "mhilgendorf@viracon.com"
    },
    {
        id: 33,
        name: "Asia – Hilgendorf",
        email: "mhilgendorf@viracon.com"
    },
    {
        id: 34,
        name: "Taiwan - Hilgendorf",
        email: "mhilgendorf@viracon.com"
    }
]

export const SALE_TERRITORY_TYPE_CONSTANTS_ARCHIVE = [
    {
        id: 1,
        name: "007 - Hoffman",
        email: "rhoffman@viracon.com"
    },
    {
        id: 2,
        name: "101 - Davidson",
        email: "Allend@addassoc.com"
    },
    {
        id: 3,
        name: "103 - Sawyer",
        email: "jsawyer@viracon.com"
    },
    {
        id: 4,
        name: "104 - Martineau & Co.",
        email: "nicole@mandcomp.com"
    },
    {
        id: 5,
        name: "105 - Kennedy",
        email: "akennedy@dv8glazing.com"
    },
    {
        id: 6,
        name: "107 - Hawkins",
        email: "mh@anchor-architectural.com"
    },
    {
        id: 7,
        name: "108 - Sweet",
        email: "jsweet@viracon.com"
    },
    {
        id: 8,
        name: "202 - Urich",
        email: "durich@archonfentech.com"
    },
    {
        id: 9,
        name: "203 - Carlson",
        email: "bcarlson@viracon.com"
    },
    {
        id: 10,
        name: "204 - Krier",
        email: "matt@truenorthfacades.com"
    },
    {
        id: 11,
        name: "205 - Honaman",
        email: "lhonaman@viracon.com"
    },
    {
        id: 12,
        name: "302 - Winkler",
        email: "mwinkler@viracon.com"
    },
    {
        id: 13,
        name: "303 - Johnson",
        email: "jeffjohnson@viracon.com"
    },
    {
        id: 14,
        name: "305 - PGP",
        email: "jhemby@pgp-usa.com"
    },
    {
        id: 15,
        name: "308 - Rigot",
        email: "jrigot@viracon.com"
    },
    {
        id: 16,
        name: "400 - Western Canada",
        email: "rhoffman@viracon.com"
    },
    {
        id: 17,
        name: "401 - Dorsey",
        email: "kdorsey@viracon.com"
    },
    {
        id: 18,
        name: "402 - O'Neill",
        email: "connor@orhize.com"
    },
    {
        id: 19,
        name: "403 - JPaal",
        email: "jack@bpaproducts.net"
    },
    {
        id: 20,
        name: "404 - JRobson",
        email: "jeff@bpaproducts.com"
    },
    {
        id: 21,
        name: "405 - Hoffman",
        email: "rhoffman@viracon.com"
    },
    {
        id: 22,
        name: "Puerto Rico - Rigot",
        email: "jrigot@viracon.com"
    },
    {
        id: 23,
        name: "Dominican Republic - Rigot",
        email: "jrigot@viracon.com"
    },
    {
        id: 24,
        name: "Bahamas - Rigot",
        email: "jrigot@viracon.com"
    },
    {
        id: 25,
        name: "Cayman Islands - Rigot",
        email: "jrigot@viracon.com"
    },
    {
        id: 26,
        name: "Misc. Latin America - Hoffman",
        email: "rhoffman@viracon.com"
    },
    {
        id: 27,
        name: "Mexico - Hoffman",
        email: "rhoffman@viracon.com"
    },
    {
        id: 28,
        name: "Costa Rica - Hoffman",
        email: "rhoffman@viracon.com"
    },
    {
        id: 29,
        name: "New Zealand – Hilgendorf",
        email: "mhilgendorf@viracon.com"
    },
    {
        id: 30,
        name: "Middle East – Hilgendorf",
        email: "mhilgendorf@viracon.com"
    },
    {
        id: 31,
        name: "South Korea – Hilgendorf",
        email: "mhilgendorf@viracon.com"
    },
    {
        id: 32,
        name: "Vietnam – Hilgendorf",
        email: "mhilgendorf@viracon.com"
    },
    {
        id: 33,
        name: "Asia – Hilgendorf",
        email: "mhilgendorf@viracon.com"
    },
    {
        id: 34,
        name: "Taiwan - Hilgendorf",
        email: "mhilgendorf@viracon.com"
    },
    // After this part this is only for archive purposes
    {
        id: 35,
        name: "401 - Bauman",
        email: "jbauman@viracon.com"
    },
    {
        id: 36,
        name: "405 - Stephens",
        email: "bstephens@ltsna.com"
    },
]

export const PROJECT_TYPE_CONSTANTS = [
    {
        id: 10,
        name: "Entertainment"
    },
    {
        id: 20,
        name: "Government"
    },
    {
        id: 30,
        name: "Educational"
    },
    {
        id: 40,
        name: "Medical"
    },
    {
        id: 50,
        name: "Hotels/Motels"
    },
    {
        id: 60,
        name: "Manufacturing"
    },
    {
        id: 70,
        name: "Multifamily Housing"
    },
    {
        id: 80,
        name: "Comm. Office Space"
    },
    {
        id: 90,
        name: "Airport/Transportation"
    },
    {
        id: 100,
        name: "Detention"
    },
    {
        id: 110,
        name: "Religious"
    },
    {
        id: 120,
        name: "Store/Shopping Center"
    },
    {
        id: 130,
        name: "Warehouse"
    },
    {
        id: 140,
        name: "Misc"
    }
]

export const DESTINATION_CONSTANTS = [
    { id: 1, name: 'Domestic' },
    { id: 2, name: 'International' }
]

export const COUNTRY_CONSTANT = [
    { id: 1, name: "Canada", leadtime: 4, countryCode: "CA" },
    { id: 2, name: "Argentina", leadtime: 10, countryCode: "AR" },
    { id: 3, name: "Australia", leadtime: 10, countryCode: "AU" },
    { id: 4, name: "Bahamas", leadtime: 10, countryCode: "BS" },
    { id: 5, name: "Cambodia", leadtime: 10, countryCode: "KH" },
    { id: 6, name: "Cape Verde", leadtime: 10, countryCode: "CV" },
    { id: 7, name: "Chile", leadtime: 10, countryCode: "CL" },
    { id: 8, name: "China", leadtime: 10, countryCode: "CN" },
    { id: 9, name: "Costa Rica", leadtime: 10, countryCode: "CR" },
    { id: 10, name: "Dominican Republic", leadtime: 10, countryCode: "DO" },
    { id: 11, name: "Guatemala", leadtime: 10, countryCode: "GT" },
    { id: 12, name: "Hong Kong", leadtime: 10, countryCode: "HK" },
    { id: 13, name: "Indonesia", leadtime: 10, countryCode: "ID" },
    { id: 14, name: "Korea, Republic of", leadtime: 10, countryCode: "KR" },
    { id: 15, name: "Kuwait", leadtime: 10, countryCode: "KW" },
    { id: 16, name: "Macao", leadtime: 10, countryCode: "MO" },
    { id: 17, name: "Mexico", leadtime: 10, countryCode: "MX" },
    { id: 18, name: "New Zealand", leadtime: 10, countryCode: "NZ" },
    { id: 19, name: "Nicaragua", leadtime: 10, countryCode: "NI" },
    { id: 20, name: "Oman", leadtime: 10, countryCode: "OM" },
    { id: 21, name: "Panama", leadtime: 10, countryCode: "PA" },
    { id: 22, name: "Puerto Rico", leadtime: 10, countryCode: "PR" },
    { id: 23, name: "Qatar", leadtime: 10, countryCode: "QA" },
    { id: 24, name: "Singapore", leadtime: 10, countryCode: "SG" },
    { id: 25, name: "Taiwan, Province of China", leadtime: 10, countryCode: "TW" },
    { id: 26, name: "Thailand", leadtime: 10, countryCode: "TH" },
    { id: 27, name: "Trinidad and Tobago", leadtime: 10, countryCode: "TT" },
    { id: 28, name: "Turks and Caicos Islands", leadtime: 10, countryCode: "TC" },
    { id: 29, name: "United Arab Emirates", leadtime: 10, countryCode: "AE" },
    { id: 30, name: "United Kingdom", leadtime: 10, countryCode: "GB" },
    { id: 31, name: "Viet Nam", leadtime: 10, countryCode: "VN" },
    { id: 32, name: "Virgin Islands, U.S.", leadtime: 10, countryCode: "VI" },
    { id: 33, name: "Brazil", leadtime: 10, countryCode: "BR" },
    { id: 34, name: "Germany", leadtime: 10, countryCode: "DE" },
    { id: 35, name: "Israel", leadtime: 10, countryCode: "IL" },
    { id: 36, name: "Italy", leadtime: 10, countryCode: "IT" },
    { id: 37, name: "Turkey", leadtime: 10, countryCode: "TR" }
];

export const STATE_CONSTANTS = [
    {
        id: 2,
        name: "AK",
        leadtime: 2
    },
    {
        id: 3,
        name: "AL",
        leadtime: 3
    },
    {
        id: 4,
        name: "AR",
        leadtime: 3
    },
    {
        id: 5,
        name: "AZ",
        leadtime: 4
    },
    {
        id: 6,
        name: "CA",
        leadtime: 4
    },
    {
        id: 7,
        name: "CO",
        leadtime: 3
    },
    {
        id: 8,
        name: "CT",
        leadtime: 4
    },
    {
        id: 9,
        name: "DC",
        leadtime: 3
    },
    {
        id: 10,
        name: "DE",
        leadtime: 3
    },
    {
        id: 11,
        name: "FL",
        leadtime: 4
    },
    {
        id: 12,
        name: "GA",
        leadtime: 4
    },
    {
        id: 13,
        name: "HI",
        leadtime: 2
    },
    {
        id: 14,
        name: "IA",
        leadtime: 2
    },
    {
        id: 15,
        name: "ID",
        leadtime: 4
    },
    {
        id: 16,
        name: "IL",
        leadtime: 2
    },
    {
        id: 17,
        name: "IN",
        leadtime: 2
    },
    {
        id: 18,
        name: "KS",
        leadtime: 2
    },
    {
        id: 19,
        name: "KY",
        leadtime: 2
    },
    {
        id: 20,
        name: "LA",
        leadtime: 3
    },
    {
        id: 21,
        name: "MA",
        leadtime: 4
    },
    {
        id: 22,
        name: "MD",
        leadtime: 3
    },
    {
        id: 23,
        name: "ME",
        leadtime: 4
    },
    {
        id: 24,
        name: "MI",
        leadtime: 2
    },
    {
        id: 25,
        name: "MN",
        leadtime: 1
    },
    {
        id: 26,
        name: "MO",
        leadtime: 2
    },
    {
        id: 27,
        name: "MS",
        leadtime: 3
    },
    {
        id: 28,
        name: "MT",
        leadtime: 3
    },
    {
        id: 29,
        name: "NC",
        leadtime: 3
    },
    {
        id: 30,
        name: "ND",
        leadtime: 2
    },
    {
        id: 31,
        name: "NE",
        leadtime: 2
    },
    {
        id: 32,
        name: "NH",
        leadtime: 4
    },
    {
        id: 33,
        name: "NJ",
        leadtime: 4
    },
    {
        id: 34,
        name: "NM",
        leadtime: 3
    },
    {
        id: 35,
        name: "NV",
        leadtime: 4
    },
    {
        id: 36,
        name: "NY",
        leadtime: 4
    },
    {
        id: 37,
        name: "OH",
        leadtime: 2
    },
    {
        id: 38,
        name: "OK",
        leadtime: 3
    },
    {
        id: 39,
        name: "OR",
        leadtime: 4
    },
    {
        id: 40,
        name: "PA",
        leadtime: 4
    },
    {
        id: 41,
        name: "RI",
        leadtime: 4
    },
    {
        id: 42,
        name: "SC",
        leadtime: 3
    },
    {
        id: 43,
        name: "SD",
        leadtime: 2
    },
    {
        id: 44,
        name: "TN",
        leadtime: 3
    },
    {
        id: 45,
        name: "TX",
        leadtime: 3
    },
    {
        id: 46,
        name: "UT",
        leadtime: 4
    },
    {
        id: 47,
        name: "VA",
        leadtime: 3
    },
    {
        id: 48,
        name: "VT",
        leadtime: 4
    },
    {
        id: 49,
        name: "WA",
        leadtime: 4
    },
    {
        id: 50,
        name: "WI",
        leadtime: 2
    },
    {
        id: 51,
        name: "WV",
        leadtime: 3
    },
    {
        id: 52,
        name: "WY",
        leadtime: 3
    }
]

export const QUANTITY_CONSTANTS = [
    {
        id: 1,
        value: 1,
    },
    {
        id: 2,
        value: 2,
    },
    {
        id: 3,
        value: 3,
    },
    {
        id: 4,
        value: 4,
    },
    {
        id: 5,
        value: 5,
    },
    {
        id: 6,
        value: 6,
    },
    {
        id: 7,
        value: 7,
    },
    {
        id: 8,
        value: 8,
    },
    {
        id: 9,
        value: 9,
    },
    {
        id: 10,
        value: 10,
    },
]

export const SAMPLE_SIZE_CONSTANTS = [
    {
        id: 1,
        value: '12x12',
    },
    {
        id: 2,
        value: '5x7 (IGU)',
    },
    {
        id: 3,
        value: '4x6 (Mono, Lami)',
    },
    {
        id: 4,
        value: '2x6',
    },
    {
        id: 5,
        value: '14x20 (VIG Only)',
    },
]

export const ORDER_STATUS_CONSTANTS = [
    {
        id: 1,
        value: 'Pending',
    },
    {
        id: 2,
        value: 'In Production',
    },
    {
        id: 3,
        value: 'Ready For Shipment',
    },
]